var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"grid gap-6 lg:grid-cols-2 lg:px-16 lg:pl:20 md:mb-16 lg:mb-0"},[_c('HeroText'),_c('HeroMap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }